import { secretKey } from "../../util/config";
import * as ActionType from "./admin.type";
import jwt_decode from "jwt-decode";
import setToken from "../../util/setToken";
import SetDevKey from "../../util/devkey";

const initialState = {
  admin: {},
  admins: [],
  isAuth: false,
};

export const adminReducer = (state = initialState, action) => {
  let decode;
  switch (action.type) {
    case ActionType.LOGIN_ADMIN:
      if (action.payload) {
        decode = jwt_decode(action.payload);
      }
      setToken(action.payload);
      SetDevKey(secretKey);
      localStorage.setItem("token", action.payload);
      localStorage.setItem("key", secretKey);
      localStorage.setItem("isAuth", true);
      return {
        ...state,
        admin: decode,
        isAuth: true,
      };
    case ActionType.PROFILE_ADMIN:
      return {
        ...state,
        admin: {
          ...state.admin,
          id: action.payload._id,
          name: action.payload.name,
          email: action.payload.email,
          image: action.payload.image,
          flag: action.payload.flag,
          role: action.payload.role,
          fcm_token: action.payload.fcm_token,
          wallet: action.payload.wallet,
          uniqueId: action.payload.uniqueId,
        },
      };
    case ActionType.LOGOUT_ADMIN:
      localStorage.removeItem("key", secretKey);
      localStorage.removeItem("token", setToken);
      setToken(null);
      SetDevKey(null);
      return {
        ...state,
        isAuth: false,
        admin: {},
      };
    case ActionType.UPDATE_IMAGE_PROFILE:
      return {
        ...state,
        admin: {
          ...state.admin,
          name: action.payload.name,
          image: action.payload.image,
        },
      };

    case ActionType.UPDATE_PROFILE:
      return {
        ...state,
        admin: action.payload,
      };
    case ActionType.GET_ADMINS:
      return {
        ...state,
        admins: action.payload,
      };
    case ActionType.ADD_ADMIN:
      return {
        ...state,
        admins: [action.payload, ...state.admins],
      };
    case ActionType.EDIT_ADMIN:
      return {
        ...state,
        admins: state.admins.map((admin) => (admin._id.toString() === action.payload.id.toString() ? action.payload.data : admin)),
      };
    case ActionType.BLOCK_ADMIN:
      return {
        ...state,
        admins: state.admins.map((admin) => (admin._id.toString() === action.payload._id.toString() ? action.payload : admin)),
      };
    case ActionType.DELETE_ADMIN:
      return {
        ...state,
        admins: state.admins.filter((admin) => admin._id !== action.payload),
      };
    default:
      return state;
  }
};
